
import Vue from 'vue'
import * as Api from '@/api/SchoolSettingsApi'
import { SchoolStudentDto } from '@ViewModels/SchoolStudentDto'
import { DataSet } from '@/services'

export default Vue.extend({
   name: 'StudentList',
   props: {
      schoolId: String,
      dataset: Object as () => DataSet,
      classroomOptions: Array as () => NameValuePair[],
   },
   data() {
      return {
         classroomId: 'NONE',
      }
   },
   computed: {
      selectedStudents(): any[] {
         if (!this.dataset) {
            return []
         }
         return this.dataset.items.filter(i => i.IsSelected === true)
      },
      selectedStudentCount(): number {
         return this.selectedStudents.length
      },
   },
   methods: {
      async makeActive() {
         const students = this.selectedStudents.filter(
            (student: SchoolStudentDto) => !student.IsEnabled
         )

         for (const student of students) {
            await Api.activateStudent(student.Id)
         }

         this.$toast.success(`${this.selectedStudentCount} made active`)
         this.$emit('change')
      },
      async makeInactive() {
         const students = this.selectedStudents.filter(
            (student: SchoolStudentDto) => student.IsEnabled
         )

         for (const student of students) {
            await Api.deactivateStudent(student.Id)
         }

         this.$toast.success(`${this.selectedStudentCount} made inactive`)
         this.$emit('change')
      },
      async moveToClass() {
         if (!this.classroomId || this.classroomId === 'NONE') {
            return
         }

         const students = this.selectedStudents

         for (const student of students) {
            // Remove from existing classrooms
            const oldClassrooms = student.ClassRoomIds.filter(
               (id: string) => id !== this.classroomId
            )
            
            for (const classroomId of oldClassrooms) {
               await Api.removeStudentFromClass(student.Id, classroomId)
            }

            // Add to selected classroom
            await Api.addStudentToClass(student.Id, this.classroomId)
         }

         this.$toast.success(`${this.selectedStudentCount} students moved`)
         this.$emit('change')
      },
   },
})
